export function StepFindContacts() {
  throw new Error('StepFindContacts is not available on web')
}
